import { compile } from 'path-to-regexp';

export default (path, params) => compile(path, { encode: encodeURIComponent })(params);